<template>
  <base-modal :show="showModal" @controleModalApperance="$emit('closeModal')">
    <template #modal>
      <div class="modal_card">
        <div class="modal_header">
          <h5>{{ $t("walletRequests.rejectRequest") }}</h5>
          <button class="close_btn" @click="$emit('closeModal')">
            <i class="fal fa-times"></i>
          </button>
        </div>

        <div class="modal_body">
          <div class="reject_request_wrapper" v-if="requestData">
            <form @submit.prevent="submitForm">
              <div class="row">
                <!-- Start:: Request Info -->
                <div class="col-12 mb-3">
                  <div class="info_card">
                    <div class="info_row">
                      <label>{{ $t("walletRequests.requestId") }}:</label>
                      <span>#{{ requestData.id }}</span>
                    </div>
                    <div class="info_row">
                      <label>{{ $t("walletRequests.providerName") }}:</label>
                      <span>{{ requestData.user?.name }}</span>
                    </div>
                    <div class="info_row">
                      <label>{{ $t("walletRequests.requestedAmount") }}:</label>
                      <span class="font-weight-bold">{{
                        requestData.balance
                      }}</span>
                    </div>
                  </div>
                </div>
                <!-- End:: Request Info -->

                <!-- Start:: Rejection Reason Input -->
                <div class="col-12 mb-3">
                  <label class="d-block mb-2">
                    {{ $t("walletRequests.rejectionReason") }} *
                  </label>
                  <textarea
                    class="form-control"
                    rows="4"
                    :placeholder="
                      $t('walletRequests.rejectionReasonPlaceholder')
                    "
                    v-model="formData.notes"
                    required
                  ></textarea>
                </div>
                <!-- End:: Rejection Reason Input -->

                <!-- Start:: Warning Alert -->
                <div class="col-12 mb-3">
                  <div class="alert alert-warning">
                    <i class="fal fa-exclamation-triangle"></i>
                    {{ $t("walletRequests.rejectConfirmMessage") }}
                  </div>
                </div>
                <!-- End:: Warning Alert -->
              </div>

              <!-- Start:: Submit Buttons -->
              <div class="form_submit_btn_wrapper">
                <button
                  type="submit"
                  class="btn btn-danger"
                  :disabled="isSubmitting || !formData.notes"
                >
                  {{ $t("walletRequests.reject") }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="$emit('closeModal')"
                >
                  {{ $t("walletRequests.cancel") }}
                </button>
              </div>
              <!-- End:: Submit Buttons -->
            </form>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from "@/components/ui/BaseModal.vue";

export default {
  name: "RejectWalletRequestModal",

  components: {
    BaseModal,
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    requestData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      // Start:: Form Data
      formData: {
        notes: "",
      },
      isSubmitting: false,
      // End:: Form Data
    };
  },

  watch: {
    requestData: {
      handler(newVal) {
        if (newVal) {
          this.formData.notes = "";
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    // Start:: Submit Form
    async submitForm() {
      if (!this.formData.notes.trim()) {
        this.$message.error(this.$t("rejection_reason_required"));
        return;
      }

      this.isSubmitting = true;
      try {
        await this.$axios({
          method: "POST",
          url: "wallets/submit-requests-wallet",
          data: {
            wallet_request_id: this.requestData.id,
            status: "rejected",
            notes: this.formData.notes,
          },
        });

        this.$message.success(this.$t("walletRequests.rejectSuccess"));
        this.$emit("refreshData");
        this.$emit("closeModal");
        this.resetForm();
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || this.$t("errorOccurred")
        );
      } finally {
        this.isSubmitting = false;
      }
    },
    // End:: Submit Form

    // Start:: Reset Form
    resetForm() {
      this.formData = {
        notes: "",
      };
    },
    // End:: Reset Form
  },
};
</script>

<style scoped lang="scss">
.modal_card {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .modal_header {
    padding: 20px 25px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h5 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }

    .close_btn {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #999;
      padding: 5px 10px;

      &:hover {
        color: #333;
      }
    }
  }

  .modal_body {
    overflow-y: auto;
    flex: 1;
  }
}

.reject_request_wrapper {
  padding: 20px;

  .info_card {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 15px;

    .info_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      label {
        font-size: 14px;
        font-weight: 600;
        color: #666;
        margin: 0;
      }

      span {
        font-size: 14px;
        color: #333;
      }
    }
  }

  .alert {
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      font-size: 18px;
    }
  }

  .form_submit_btn_wrapper {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>
